import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { App } from '../app';

export const authGuard: CanActivateFn = () => {
  if (App.credentials) {
    return true;
  }
  const router = inject(Router);
  return router.parseUrl('/admin');
};
